module.exports = __webpack_public_path__ + "media/images/icons/illustration/guest-b4830aa98f9674d6c20c86a68388e539.svg";